import { Injectable } from '@angular/core';

import { AppListenerService, getWindowRef } from '@hiptraveler/common';
import { PromptDialogActionService } from '@hiptraveler/dialogs/prompt-dialog';
import { SocialApiPopupService, SocialMediaType } from '@hiptraveler/data-access/api';

interface ValidateEvent {
  invalid: boolean
}

@Injectable()
export class SocialMediaEventService {

  constructor(
    private appListener: AppListenerService,
    private socialApi: SocialApiPopupService,
    private promptDialog: PromptDialogActionService,
  ) { }

  get isMobile(): boolean {
    return this.appListener.clientWidth$$.value < 700;;
  }

  validateEvent(type: SocialMediaType): ValidateEvent {

    const stopCondition = type === 'instagram' && this.isMobile;

    if (stopCondition && type === 'instagram') {
      this.instagramCond();
    }

    return {
      invalid: stopCondition
    }
  }

  instagramCond(): void {
    this.promptDialog.open({
      title: 'Continue in Browser',
      message: 'To complete Instagram linking, please do not open the app. Continue the flow in your mobile browser.',
      buttons: [
        {
          name: 'Cancel',
          executable: () => {
            this.promptDialog.instance.close();
          },
          theme: 'white'
        },
        {
          name: 'Ok',
          executable: () => {

            const { url, csrfState } = this.socialApi.buildSocialMediaAuthUrl('instagram');
            this.socialApi.observeSocialAuth('instagram', csrfState);

            getWindowRef()?.open(url, '_blank');
            this.promptDialog.instance.close();
          },
          theme: 'white-primary-accent'
        }
      ]
    });
  }

}
